import { KubesoloHostResult, KubesoloStep, KubesoloTest } from '@api/types.gen';

const SECOND_MS = 1000;
const MINUTE_MS = 60 * SECOND_MS;

/** 0s, 20s or 1m 04s */
export function formatDuration(ms: number) {
  if (ms < MINUTE_MS) {
    return `${Math.floor(ms / SECOND_MS)}s`;
  }

  const seconds = Math.floor((ms % MINUTE_MS) / SECOND_MS);
  return `${Math.floor(ms / MINUTE_MS)}m ${String(seconds).padStart(2, '0')}s`;
}

/** How long the machine's steps have taken, so far while it runs. */
export function hostDurationMs(host: KubesoloHostResult, now: number) {
  return host.steps.reduce(
    (total, step) => total + stepDurationMs(step, now),
    0
  );
}

/** How long the step took, counting on from the last poll while it runs. */
export function stepDurationMs(step: KubesoloStep, now: number) {
  if (step.state !== 'running' || !step.startedAt) {
    return step.durationMs;
  }

  return Math.max(step.durationMs, now - new Date(step.startedAt).getTime());
}

/** When the last step of the test ended, or now while machines are queued or running. */
export function testEndMs(test: KubesoloTest, now: number) {
  if (test.counts.queued + test.counts.running > 0) {
    return now;
  }

  const stepEnds = test.hosts.flatMap((host) =>
    host.steps.flatMap((step) =>
      step.startedAt
        ? [new Date(step.startedAt).getTime() + step.durationMs]
        : []
    )
  );

  return Math.max(new Date(test.createdAt).getTime(), ...stepEnds);
}
